<template>
  <FlexCol gap-1>
    <Label v-if="label" :label="label" :required="required" :error="error" />
    <InputArc :disabled="disabled" :error="error">
      <template #input>
        <input
          v-model="displayValue"
          :disabled="disabled"
          :placeholder="placeholder"
          type="text"
          class="w-full bg-transparent focus:outline-none focus:ring-0 placeholder:italic disabled:text-gray-500 disabled:cursor-not-allowed" />
      </template>
      <template #pos-icon>
        <button
          type="button"
          class="h-full border-l border-slate-200 px-3 text-sm font-semibold text-primary-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-400"
          :disabled="disabled || !isValidUrl"
          @click="openLink">
          <i class="fa-solid fa-up-right-from-square"></i>
        </button>
      </template>
    </InputArc>
    <Error v-if="error" :message="error" />
  </FlexCol>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: {
    type: [Array, String, Object],
    default: null,
  },
  modelValue: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: 'https://...',
  },
})

const emit = defineEmits(['update:modelValue'])

const displayValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const isValidUrl = computed(() => {
  const value = String(props.modelValue ?? '').trim()
  if (!value) return false
  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
})

const openLink = () => {
  if (!isValidUrl.value) return
  window.open(props.modelValue, '_blank', 'noopener,noreferrer')
}
</script>
